<script>
    let className = '';
    export { className as class };
</script>

<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class={className}>
    <circle cx="12" cy="12" r="12" fill="black" opacity="0.15" />
    <circle opacity="0.15" cx="12" cy="12" r="10" fill="white" />
    <g opacity="0.25">
        <path
            d="M12 2C11.0223 2 10.0848 2.09698 9.18746 2.29095L9.45532 3.34698C9.4955 3.5625 9.8705 3.875 10.2723 3.875H13.7276C14.1294 3.875 14.5044 3.5625 14.558 3.34698L14.8125 2.29095C13.9151 2.09698 12.9776 2 12 2Z"
            fill="white"
        />
        <path
            d="M3.3047 7.01765C2.8981 7.73236 2.60374 8.47434 2.4082 9.22225L3.59318 9.51372C3.82995 9.56762 4.30391 9.44413 4.47403 9.16006L5.94374 6.6066C6.1133 6.31155 5.94444 5.90176 5.75285 5.76844L4.78204 5.09153C4.22013 5.66005 3.71131 6.30293 3.3047 7.01765Z"
            fill="white"
        />
        <path
            d="M3.30271 16.966C3.70318 17.6834 4.20648 18.3299 4.76284 18.9135L5.7394 18.2459C5.93278 18.1035 6.10515 17.6957 5.93812 17.3995L4.48968 14.8475C4.32265 14.5513 3.84977 14.4239 3.61189 14.4866L2.42447 14.7674C2.61359 15.5161 2.90158 16.2597 3.30271 16.966Z"
            fill="white"
        />
        <path
            d="M12 22C12.9776 22 13.9151 21.8922 14.8125 21.7091L14.558 20.653C14.5044 20.4375 14.1294 20.125 13.7276 20.125H10.2723C9.8705 20.125 9.4955 20.4375 9.45532 20.653L9.18746 21.7091C10.0848 21.8922 11.0223 22 12 22Z"
            fill="white"
        />
        <path
            d="M20.6915 16.9793C21.1161 16.2784 21.4034 15.5398 21.604 14.794L20.4192 14.4956C20.1819 14.4293 19.7065 14.5497 19.5348 14.8433L18.046 17.3735C17.8866 17.6666 18.0408 18.0774 18.2323 18.2227L19.2001 18.9048C19.7783 18.329 20.2797 17.6906 20.6915 16.9793Z"
            fill="white"
        />
        <path
            d="M20.6928 7.01472C20.2832 6.30129 19.7838 5.66062 19.2069 5.09329L18.237 5.77328C18.0455 5.9072 17.8901 6.31812 18.0486 6.61205L19.5289 9.16083C19.7002 9.44436 20.1752 9.56635 20.4122 9.5117L21.5979 9.21647C21.3996 8.46919 21.1147 7.72873 20.6928 7.01472Z"
            fill="white"
        />
    </g>
    <path
        d="M12 6C15.307 6 18 8.69302 18 12C18 15.307 15.307 18 12 18C8.69302 18 6 15.307 6 12C6 8.69302 8.69302 6 12 6ZM12 6.30769C8.86261 6.30769 6.30769 8.86261 6.30769 12C6.30769 15.1374 8.86261 17.6923 12 17.6923C15.1374 17.6923 17.6923 15.1374 17.6923 12C17.6923 8.86261 15.1374 6.30769 12 6.30769Z"
        fill="white"
        fill-opacity="0.3"
    />
</svg>
